// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint-input{position:absolute;top:4px;box-sizing:border-box;margin:-2px 2px;width:calc(100% - 4px);height:12px;border:none;line-height:10px;background:var(--gray1);color:var(--gray15)}\n", ""]);
